import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="current-name"
export default class extends Controller {
  static values = {
    id: String
  }

  connect () {
    const currentUserId = document.querySelector('meta[name="current-user-id"]').getAttribute('content')

    if (this.idValue === currentUserId) {
      this.element.textContent = 'You'
    }
  }
}
